import type {FC} from 'react'
import {useParams} from 'react-router-dom'
import templatesData from '../../../data/sales/salesTemplatesData'
import BulkRun from '../../universal-components/bulk-run/BulkRun'

interface SalesBulkRunPageProps {}

const SalesBulkRunPage: FC<SalesBulkRunPageProps> = () => {
  const {templateUrl} = useParams()
  const templateItem: any = templatesData.templates.find((item: any) =>
    item.url.includes(templateUrl)
  )
  const title = templateItem.title

  return <BulkRun title={title} templateItem={templateItem} />
}

export default SalesBulkRunPage
